<template>
  <!--
    No props are declared on purpose: every attribute and listener (variant,
    size, loading, to, onClick, class...) falls through to RevButton, which is
    the root element. This keeps OutletButton in sync with RevButton's API.
    The hover color #b9cc66 is the raw `color.raw.mindaro.79` design token, which
    has no Tailwind utility, hence the arbitrary value.
  -->
  <RevButton
    v-bind="attrs"
    class="mood-main !bg-static-brand-hi !text-action-default-hi hover:!bg-[#b9cc66]"
  >
    <slot />
  </RevButton>
</template>

<script setup lang="ts">
import { useAttrs } from 'vue'

import { RevButton } from '@ds/components/Button'

type RevButtonProps = InstanceType<typeof RevButton>['$props']

defineOptions({ inheritAttrs: false })

// Attrs are untyped by nature: cast so RevButton still type-checks its template.
const attrs = useAttrs() as unknown as RevButtonProps
</script>
